// removed by extract-text-webpack-plugin
module.exports = {"block":"_1UDEzLPR4p7pE5Z8k4H1qs","zebra":"_7jGdwkdxIiyOuBUZKGP0e","content":"_1sF77spDpM8qMqEznLUQzD","has-overflow":"lOMa1zgla9Y9oSIpIZoR_","yellow":"_2xFdNhcxmOZg-dU_00Kx62","darkgray":"_3tTV-NaDw764obK509XEod","table-text":"HULV2DmPi7tsT5VINO31z","heading":"_1fsIyjeFBWA5iX1GIVs-kP","had-interaction":"_1w-YTVuV4MUfY-S9bYGQh_","swipe-hint":"_1Bp5yPW3-Sb-ciYW5Rv9gN","table-swipe":"_2odlz3YM54K9wXlLV284BT","swipe-hint-hand":"RnEYHx_pS2LHk3yOdaqjg","swipe-hint-trail":"_1LdoAphEO7ROgLUDLAmsuM","readMore":"_1wH6W-p1Y_fdPHuCbe9v6t","rightAlign":"_19E9FzGJhapovfwukOOwoc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TableBlock/TableBlock.module.scss
// module id = 810
// module chunks = 0